import {Grid, Stack} from '@mui/material';
import {AppControlledInput} from 'components/form';
import React from 'react';
import {FieldsRendererProps} from '.';
interface Props extends FieldsRendererProps {
    gridSize?: number;
}

export const RenderNumberField: React.FC<Props> = ({field, control, gridSize, baseFieldName}) => {
    // const {getItemDataValueWithFormulaApplied} = useItemDataHelper();
    // const [readOnlyValue, setReadOnlyValue] = useState<string>();
    // useEffect(() => {
    //     if (field.formula && field.formula !== '') {
    //         const value = getItemDataValueWithFormulaApplied(field, itemSummaryVariables ?? []);

    //         if (value && !field.isReadOnly) {
    //             //check value is a number
    //             if (isNaN(Number(value))) {
    //                 setValue(`data.${indexKey}`, {...field, value: {...field.value, integerValue: Number(value)}});
    //             } else {
    //                 console.error(`Invalid formula result for field ${field.title}: ${value} is not a number.`);
    //             }
    //         } else {
    //             setReadOnlyValue(value);
    //         }
    //     } else {
    //         setReadOnlyValue(field.value.integerValue?.toString() ?? '0');
    //     }
    // }, [field.formula]);

    return (
        <Grid item md={gridSize} xs={12}>
            <Stack spacing={1}>
                <AppControlledInput
                    label={field.title}
                    fullWidth
                    type="number"
                    name={`${baseFieldName}.integerValue`}
                    control={control}
                    required={field.isRequired}
                    placeholder={field.placeHolder}
                />
            </Stack>
        </Grid>
    );
};

export default RenderNumberField;
